export default "__VITE_PUBLIC_ASSET__1b00547e__"